import {Injectable} from '@angular/core';
import * as ExcelJS from 'exceljs';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {
  constructor() {
  }

  /** "A" → 1, "Z" → 26, "AA" → 27, "AB" → 28 */
  public columnToIndex(letter: string): number | undefined {
    if (!/^[A-Za-z]+$/.test(letter)) {
      return undefined;
    }

    let index = 0;
    for (const char of letter.toUpperCase()) {
      index = index * 26 + (char.codePointAt(0)! - 64); // 'A'.codePointAt(0) === 65
    }
    return index;
  };

  public fromCol(letter: string, row: ExcelJS.Row): string | undefined {
    const trimmedLetter = letter?.trim();
    if (!trimmedLetter) {
      return undefined;
    }

    const index = this.columnToIndex(letter);
    if (index === undefined) {
      return undefined;
    }

    return row.getCell(index).text?.trim() || undefined;
  };
}
